<script>
    import {fitText} from "../svg/text";
    import {onMount} from "svelte";

    export let landformElements = [];

    let width = 400;
    let height = 100;

    const padding = 5;

    let svg;

    function resize() {
        width = svg.getBoundingClientRect().width;
    }

    const paddingPerLevel = 16;
    const initialPadding = 16;
    const lineHeight = 16;
    const paddingRight = 8;

    $: sections = landformElements.map(({tierLabel, name, technicalSummary}, i) => {
        const dx = i * paddingPerLevel;
        const maxWidth = width - (dx + initialPadding + paddingRight);
        const heading = fitText([tierLabel, name].join(" - "), maxWidth);

        const headingLines = heading.map(text => ({
            parts: [
                { text: tierLabel, fontWeight: "bold" },
                {
                    text: " - " + name
                }
            ],
            dx,
            emphasisOn: tierLabel.length
        }))

        const summary = technicalSummary && fitText(technicalSummary, maxWidth) || [];

        const lines = [
            ...headingLines,
            ...(summary.map(text => ({
                parts: [{ text }],
                dx
            })))
        ];

        return {
            dx,
            lines,
            height: lines.length * lineHeight
        };
    }).reduce((soFar, section, idx) => {
        const dy = idx > 0 ? soFar[idx - 1].dy + soFar[idx - 1].height + spacing : 0;
        return [
            ...soFar,
            {
                ...section,
                dy
            }
        ]
    }, []);

    const spacing = 10;

    $: height = sections.reduce((a, s) => a + s.height, 0) + (sections.length - 1) * spacing;

    function makePath(someSections) {
        if (!someSections || !someSections.length) return undefined;

        let previousSection = someSections[0];

        let x = initialPadding,
            y = previousSection.height / 2 - 2;

        let path = `M 0 ${y} h ${initialPadding} m -${initialPadding} 0`;

        for (let section of someSections.slice(1)) {
            x += paddingPerLevel;
            // draw vertical segment from previous section to current section
            path += ` v ${(previousSection.height + section.height) / 2 + spacing}`
            // draw horizontal segment
            path += ` h ${paddingPerLevel + initialPadding}`
            // back track to middle of horizontal segment
            path += ` m -${(paddingPerLevel + initialPadding) / 2} 0`
            previousSection = section;
        }

        return path;
    }

    $: pathShape = makePath(sections);

    onMount(() => {
        resize();
    })
</script>

<svelte:window on:resize={resize} />

<svg viewBox={`-5 -5 ${width + 5} ${height + 5}`} xmlns="http://www.w3.org/2000/svg" bind:this={svg}>
    <path d={pathShape} fill="transparent" stroke="black" stroke-width="2" />
    <text x={initialPadding} y="0" dominant-baseline="hanging">
        {#each sections as section}
            {#each section.lines as line, j}
                <tspan x={initialPadding} y="0" dx={line.dx + 4} dy={section.dy + j * lineHeight}>
                    {#each line.parts as part}
                        <tspan font-weight={part.fontWeight ? part.fontWeight : undefined}>
                            { part.text }
                        </tspan>
                    {/each}
                </tspan>
            {/each}
        {/each}
    </text>
</svg>

<style>
    svg {
        width: 100%;
    }
</style>
